import styles from './index.scss'
import React, { useRef, useState, useEffect } from 'react'
import { ActionSheet } from 'antd-mobile'
import { memberInfo } from '@/services/index'
import goTo from '@/libs/functions/goTo'
import Layout from '@/libs/components/Layout'
import { orderStatusList, OrderStatusType } from '@/libs/globalData'

type InfoDataType = {
  mobile: string
  userCode: string
}

// 恒丰项目个人中心个性化
export default function Personal() {
  const [infoData, setInfoData] = useState<InfoDataType>({
    mobile: '',
    userCode: '',
  })
  const [visiblePhone, setVisiblePhone] = useState(false)

  useEffect(() => {
    memberInfo().then((res: any) => {
      setInfoData(res)
    })
  }, [])
  return (
    <Layout title="个人中心">
      <div className={styles.personalPage}>
        <div className={styles.info}>
          <img
            src={require('@/assets/image/img_portrait.png')}
            className={styles.avatar}
          />
          <div className={styles.phone}>{infoData.mobile}</div>
        </div>
        <div className={styles.orderHistory}>
          <div className={styles.title}>订单记录</div>
          <div className={styles.list}>
            {orderStatusList.map((v: OrderStatusType) => (
              <div
                className={styles.item}
                key={v.value}
                onClick={() => goTo(`/order/orderRecord?status=${v.value}`)}
              >
                <img
                  className={styles.icon}
                  src={require(`@/assets/image/${v.icon}`)}
                />
                <div className={styles.text}>{v.label}</div>
              </div>
            ))}
          </div>
        </div>
        <div className={styles.cellGroup}>
          <a className={styles.cell} onClick={() => goTo(`/equity/equityList`)}>
            <div className={styles.left}>
              <img
                className={styles.icon}
                src={require('@/assets/image/ico_list.png')}
              />
              <div className={styles.title}>权益列表</div>
            </div>
            <div className={styles.right}>
              <img
                className={styles.arrows}
                src={require('@/assets/image/ico_enter.png')}
              />
            </div>
          </a>
          <a
            className={styles.cell}
            onClick={() => goTo(`/discountCouponList`)}
          >
            <div className={styles.left}>
              <img
                className={styles.icon}
                src={require('@/assets/image/ico_discountCouponList.png')}
              />
              <div className={styles.title}>优惠券</div>
            </div>
            <div className={styles.right}>
              <img
                className={styles.arrows}
                src={require('@/assets/image/ico_enter.png')}
              />
            </div>
          </a>
          <a
            className={styles.cell}
            onClick={() => goTo(`/equity/codeExchange`)}
          >
            <div className={styles.left}>
              <img
                className={styles.icon}
                src={require('@/assets/image/ico_exchange.png')}
              />
              <div className={styles.title}>兑换码</div>
            </div>
            <div className={styles.right}>
              <img
                className={styles.arrows}
                src={require('@/assets/image/ico_enter.png')}
              />
            </div>
          </a>
          <a className={styles.cell} onClick={() => setVisiblePhone(true)}>
            <div className={styles.left}>
              <img
                className={styles.icon}
                src={require('@/assets/image/ico_service.png')}
              />
              <div className={styles.title}>联系客服</div>
            </div>
            <div className={styles.right}>
              <div className={styles.value}>400-882-1111</div>
              <img
                className={styles.arrows}
                src={require('@/assets/image/ico_enter.png')}
              />
            </div>
          </a>
        </div>
        <ActionSheet
          extra="联系客服"
          visible={visiblePhone}
          actions={[
            {
              text: '400-882-1111',
              key: 'phone',
              onClick: () => {
                window.location.href = 'tel://400-882-1111'
              },
            },
          ]}
          onClose={() => setVisiblePhone(false)}
        />
      </div>
    </Layout>
  )
}
